import { RepairContainer } from '../../containers/advancedFilters/RepairContainer';
import { IFilter } from '../../types/filters';

export const repair: IFilter = {
  component: RepairContainer,
};
